import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { launchColors } from '../launchTheme';

export type SaveState = 'idle' | 'saving' | 'saved' | 'error';

export const saveStamp = (date = new Date()): string => date.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });

const SaveIndicator: React.FC<{ state: SaveState; savedAt?: string }> = ({ state, savedAt }) => (
  <Box aria-live="polite" sx={{ minHeight: 20, display: 'flex', alignItems: 'center', gap: 0.5 }}>
    {state === 'saving' && (
      <>
        <CircularProgress size={12} sx={{ color: launchColors.navy }} />
        <Typography component="span" sx={{ fontSize: 12, color: launchColors.textSecondary }}>Sparar…</Typography>
      </>
    )}
    {state === 'saved' && (
      <>
        <CheckIcon sx={{ fontSize: 14, color: launchColors.moss }} />
        <Typography component="span" sx={{ fontSize: 12, color: launchColors.textSecondary }}>Sparat {savedAt}</Typography>
      </>
    )}
    {state === 'error' && (
      <Typography component="span" sx={{ fontSize: 12, fontWeight: 700, color: launchColors.dangerText }}>Kunde inte spara</Typography>
    )}
  </Box>
);

export default SaveIndicator;
